import { Link } from 'react-router-dom';
import { OnlineIcon } from '@shared/assets';
import { useAppDispatch } from '@shared/hooks';
import { openNotifyModal } from '@src/library/redux/modal';
import * as st from './styles.module.scss';

interface Props {
  href: string;
  isEventStarted: boolean;
}

export const ButtonConnect: React.FC<Props> = ({ href, isEventStarted }) => {
  const dispatch = useAppDispatch();

  const handleClickConnect: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
    if (!isEventStarted) {
      e.preventDefault();
      dispatch(
        openNotifyModal({
          // confirmText: 'Мероприятие еще не началось',
          title: 'Уведомление',
          text: 'Мероприятие еще не началось',
          confirmText: 'Понятно',
          needClose: true,
        })
      );
    }
  };

  return (
    <Link to={href} target="_blank" onClick={handleClickConnect} className={st.connect}>
      <OnlineIcon />
      <span>Подключиться</span>
    </Link>
  );
};
